"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.splitPromoCode = void 0;
const splitPromoCode = (promoCode)=>{
    var _parts_;
    const parts = promoCode.split('-');
    if (parts.length === 3 && ((_parts_ = parts[0]) === null || _parts_ === void 0 ? void 0 : _parts_.length) === 2) {
        return {
            referral: "".concat(parts[0], "-").concat(parts[1]),
            voucher: parts[2]
        };
    }
    return {
        referral: promoCode,
        voucher: undefined
    };
};
exports.splitPromoCode = splitPromoCode;
